module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"measurements":"Measurements","no_measurements":"No measurements available"},"de":{"measurements":"Messungen","no_measurements":"Keine Messungen verfügbar"},"fr":{"measurements":"Mesures","no_measurements":"Aucune mesure disponible"},"it":{"measurements":"Misurazioni","no_measurements":"Nessuna misurazione disponibile"}}')
  delete Component.options._Ctor
}
